<template>
	<div class="login">
		<b-container fluid class="bv-example-row heading">
			<b-row>
                <b-col cols="3" md="2" sm="3" xs="3">
                    <b-img src="/logo1.png" fluid class="mb-2 float-left"/>
                </b-col>
                <b-col>
                    <h2 class="text-center pt-5 font-bold">CENTRAL POLLUTION CONTROL BOARD</h2>
					<h5><i>PARIVESH BHAWAN EAST ARJUN NAGAR SHAHDARA</i></h5>
                </b-col>
                <b-col cols="3" md="2" sm="3" xs="3">
                    <b-img src="/logo2.png" fluid class="mb-2 float-right"/>
                </b-col>
            </b-row>
		</b-container>
		<b-container >
			<b-row class="justify-content-md-center mt-4"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			<b-row class="justify-content-md-center mt-4">
				<b-card class="ml-3 mr-3 mb-0 pl-0 pr-0 col-md-4 loginbox" bg-variant="info" text-variant="white" title="Login to Dashboard">
					<b-card-text>
						<form v-on:keyup.enter="login()">
							<p>
								<b-form-input v-model="email" class="pill" type="email" placeholder="Username"></b-form-input>
							</p>
							<p>
								<b-form-input v-model="password" class="pill" type="password" placeholder="Password"></b-form-input>
							</p>
						</form>
					</b-card-text>
					<b-button href="#" pill class="float-right btn-black" @click="login()">Login</b-button>
				</b-card>
			</b-row>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Login',
	components: {
	},
	beforeCreate: function() {
        document.body.className = 'login';
    },
	data() {
		return{
			email: '',
			password: '',
			error_msg: '',
		};
	},
	methods: {
		login(){
			var self = this;
			if(this.email == 'admin' && this.password == '4321'){
				self.$router.push('/dashboard');
			}else{
				this.error_msg = 'Wrong username or password!';
			}
			//alert('login '+self.email+" "+self.password);
		}
	}
}
</script>

<style>
html{
	min-height: 100%;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
</style>